import * as React from 'react'
import {useSelector} from '~/redux/hooks'
import {NoStyleLink} from '~/routing/ReactRouterLinks'
import {staticURLs} from '~/routing/sitemap'
import styles from './styles.module.css'

export function HeaderWordmark() {
  const darkMode = useSelector(state => state.settingsState.darkMode)

  return (
    <NoStyleLink to={staticURLs.dashboard}>
      <img
        alt="Kapitalist"
        className={styles.headerWordmark}
        src={`/wordmark/wordmark-bar-${darkMode ? 'dark' : 'light'}.svg`}
      />
    </NoStyleLink>
  )
}
